import React, { useState, useEffect, useCallback } from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { useParams } from 'react-router-dom';
import { getOrganisationDetail } from '../../services/api';
import Loader from '../../components/Common/Loader';

const OrganisationDetail = () => {
  const { id } = useParams();
  const [organisation, setOrganisation] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadOrganisation = useCallback(async () => {
    try {
      const response = await getOrganisationDetail(id);
      if (response.success) {
        setOrganisation(response.data);
      }
    } catch (error) {
      console.error('Error loading organisation:', error);
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    loadOrganisation();
  }, [loadOrganisation]);

  if (loading) {
    return <Loader fullHeight />;
  }

  return (
    <Box>
      <Typography variant="h4" gutterBottom fontWeight={600}>
        Organisation Details
      </Typography>
      <Paper sx={{ p: 3 }}>
        <Typography variant="body2" color="text.secondary">
          Organisation ID: {id}
        </Typography>
        {organisation && (
          <>
            <Typography variant="h6" sx={{ mt: 2 }}>{organisation.name}</Typography>
            <Typography variant="body2" color="text.secondary">
              Country: {organisation.country_name || organisation.country}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Contact: {organisation.contact_person || 'N/A'}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Email: {organisation.email || 'N/A'}
            </Typography>
          </>
        )}
      </Paper>
    </Box>
  );
};

export default OrganisationDetail;